import { render, staticRenderFns } from "./globalErrorModal.vue?vue&type=template&id=376f34f2&scoped=true"
import script from "./globalErrorModal.vue?vue&type=script&lang=js"
export * from "./globalErrorModal.vue?vue&type=script&lang=js"
import style0 from "./globalErrorModal.vue?vue&type=style&index=0&id=376f34f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f34f2",
  null
  
)

export default component.exports